import { memo, useEffect, useRef, useState } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { homeRenovationBenefits } from './data'
import * as S from './styles'

type Props = {
  onClick: () => void
}

export const HomeRenovationBenefits = memo(({ onClick }: Props) => {
  const sectionRef = useRef<HTMLElement>(null)
  const [hasEnteredViewport, setHasEnteredViewport] = useState(false)

  useEffect(() => {
    const section = sectionRef.current

    if (!section || typeof IntersectionObserver === 'undefined') {
      setHasEnteredViewport(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasEnteredViewport(true)
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )

    observer.observe(section)

    return () => observer.disconnect()
  }, [])

  return (
    <S.Section ref={sectionRef} aria-labelledby="home-renovation-benefits-title">
      <S.Content>
        <S.Heading>
          <Text
            id="home-renovation-benefits-title"
            as="h2"
            size="heading2"
            weight="medium"
            color="var(--colors-neutral-text-default)"
          >
            Quais as vantagens do <S.DesktopBreak />
            <S.Highlight>crédito para reforma</S.Highlight> da CashMe?
          </Text>
        </S.Heading>

        <S.Intro>
          <Text size="bodySmall" color="var(--colors-neutral-text-default)">
            Veja aqui por que escolher nosso <strong>Crédito com Garantia de Imóvel</strong> é mais vantajoso.
          </Text>
        </S.Intro>

        <S.CardWrapper>
          {homeRenovationBenefits.map(({ id, order, icon, title, description }) => (
            <S.Card key={id} $order={order} $isVisible={hasEnteredViewport}>
              <S.CardHeader>
                <S.Icon aria-hidden>{icon}</S.Icon>
                <S.CardTitle>
                  <Text as="h3" size="heading5" weight="medium">
                    {title}
                  </Text>
                </S.CardTitle>
              </S.CardHeader>

              <S.Description>
                <Text size="body1" color="var(--colors-neutral-text-default)">
                  {description}
                </Text>
              </S.Description>
            </S.Card>
          ))}
        </S.CardWrapper>

        <Button
          aria-label="Simular crédito para reforma de casa agora"
          size="lg"
          type="button"
          variants="text-only"
          onClick={onClick}
        >
          Simular agora
        </Button>
      </S.Content>
    </S.Section>
  )
})

HomeRenovationBenefits.displayName = 'HomeRenovationBenefits'
